import React from "react";
import { useNavigate, Link } from "react-router-dom";
import SEOHead from "../components/SEOHead";
import { getAuth } from "firebase/auth";

function PassInterview() {
  const navigate = useNavigate();
  const auth = getAuth();

  const handleStart = () => {
    if (auth.currentUser) {
      navigate("/");
    } else {
      navigate("/get-started");
    }
  };

  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "0 auto" }}>

      <SEOHead
        title="How to Pass an Interview (2026 Guide)"
        description="Learn how to pass any job interview with confidence. Discover proven strategies, common questions, and expert tips to get hired faster."
        canonical="https://employpilot.com/pass-interview"
      />

      <h1>How to Pass an Interview and Get Hired (2026 Guide)</h1>

      <p style={{ fontSize: "18px", color: "#555" }}>
        Interviews can be stressful, but the right preparation can make all the difference.
        If you know what to expect and how to respond, you can walk into any interview with confidence.
      </p>

      <p style={{ fontWeight: "bold", marginTop: "15px" }}>
        The candidates who get hired aren’t always the most experienced — they’re the most prepared.
      </p>

      <button onClick={handleStart} style={btnPrimary}>
        Practice My Interview Now
      </button>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>What Interviewers Are Really Looking For</h2>

      <ul>
        <li>✔ Confidence and clear communication</li>
        <li>✔ Relevant experience and skills</li>
        <li>✔ Problem-solving ability</li>
        <li>✔ Cultural fit</li>
      </ul>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>How to Prepare for an Interview</h2>

      <ol>
        <li>Research the company and role</li>
        <li>Practice answering common interview questions</li>
        <li>Prepare examples of your achievements</li>
        <li>Plan questions to ask the interviewer</li>
      </ol>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Common Interview Mistakes</h2>

      <ul>
        <li>❌ Not preparing answers in advance</li>
        <li>❌ Giving vague or generic responses</li>
        <li>❌ Talking too much or too little</li>
        <li>❌ Not asking questions</li>
      </ul>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Pro Tips to Stand Out</h2>

      <ul>
        <li>✔ Use specific examples (STAR method)</li>
        <li>✔ Keep answers clear and structured</li>
        <li>✔ Show enthusiasm and confidence</li>
        <li>✔ Follow up after the interview</li>
      </ul>

      {/* 🔥 INTERNAL LINKS */}
      <p style={{ marginTop: "20px" }}>
        Want to practice with AI?{" "}
        <Link to="/ai-interview-coach">
          Try the AI Interview Coach
        </Link>
      </p>

      <p>
        Need a strong resume first?{" "}
        <Link to="/ai-resume-builder">
          Build your resume here
        </Link>
      </p>

      {/* CTA */}
      <div style={{ marginTop: "50px", textAlign: "center" }}>
        <h2>Get Interview-Ready Today</h2>

        <button onClick={handleStart} style={btnSuccess}>
          Start Practicing Now
        </button>
      </div>

      {/* FAQ SECTION */}
      <h2 style={{ marginTop: "60px" }}>
        Frequently Asked Questions
      </h2>

      <h3>How can I pass an interview easily?</h3>
      <p>
        Preparation is key. Practice your answers, research the company, and focus on clear communication.
      </p>

      <h3>What is the best way to answer interview questions?</h3>
      <p>
        Use the STAR method (Situation, Task, Action, Result) to give structured and impactful answers.
      </p>

      <h3>Do interview skills really matter?</h3>
      <p>
        Yes. Strong interview performance can outweigh experience in many hiring decisions.
      </p>
<div
    style={{
      marginTop: "80px",
      textAlign: "center",
      fontSize: "14px",
      color: "#777",
      borderTop: "1px solid #eee",
      paddingTop: "30px"
    }}
  >
    © 2026 EmployPilot. All Rights Reserved.

    <div style={{ marginTop: "10px" }}>
      <a href="/terms" style={{ margin: "0 10px" }}>
        Terms of Use
      </a>

      <a href="/privacy" style={{ margin: "0 10px" }}>
        Privacy Policy
      </a>

      <a href="/contact" style={{ margin: "0 10px" }}>
        Contact
      </a>
    </div>
  </div>
</div>
  );
}

const btnPrimary = {
  backgroundColor: "#007bff",
  color: "#fff",
  padding: "12px 20px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  marginTop: "20px"
};

const btnSuccess = {
  backgroundColor: "#28a745",
  color: "#fff",
  padding: "14px 24px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer"
};

export default PassInterview;